var e = "undefined" != typeof navigator && String(navigator.userAgent) || "";
export { e };